import {inject, Injectable} from '@angular/core';
import {MultiFilesParamsService} from "./multi-files-params.service";
import {RecordCalendarFilesService} from "../../../../services/record-calendar-files.service";
import {FileTypeName, RecordCalendarFileParams} from "../../../../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class FilesParamsService {
  private multiFilesParamsService: MultiFilesParamsService = inject(MultiFilesParamsService);
  private recordCalendarFilesService: RecordCalendarFilesService = inject(RecordCalendarFilesService);

  public async getFilesParams(keys: Array<FileTypeName>, recordCalendarId: number): Promise<void> {
    for (const key of keys) {
      await this.recordCalendarFilesService.getFilesData({recordCalendarId: recordCalendarId, type: key})
        .then(recordCalendarFilesParams =>
          recordCalendarFilesParams?.forEach((recordCalendarFileParams: RecordCalendarFileParams) => {
            this.multiFilesParamsService.updateMultiFileParams(key, recordCalendarFileParams);
          })
        )
        .catch(() => null);
    }
  }
}
